import { LuSlidersHorizontal } from "react-icons/lu";
import { Button } from "../ui/button";
import { Field } from "../ui/field";
import { Input } from "../ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export function ChapterDetailsPopover({
  caption,
  tags,
  onCaptionChange,
  onTagsChange,
}: {
  caption: string;
  tags: string[];
  onCaptionChange: (caption: string) => void;
  onTagsChange: (tags: string[]) => void;
}) {
  const hasDetails = Boolean(caption.trim() || tags.length);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="relative size-8"
          aria-label="Chapter details"
          title="Chapter details"
        >
          <LuSlidersHorizontal aria-hidden />
          {hasDetails ? (
            <span
              className="absolute right-1 top-1 size-1.5 rounded-full bg-primary"
              aria-hidden
            />
          ) : null}
        </Button>
      </PopoverTrigger>
      <PopoverContent aria-label="Chapter details">
        <div className="mb-4">
          <h3 className="text-sm font-semibold text-foreground">Chapter details</h3>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
            Optional publishing and organization metadata.
          </p>
        </div>
        <div className="grid gap-4">
          <Field label="Caption" htmlFor="chapter-caption">
            <Input
              id="chapter-caption"
              placeholder="Optional chapter caption"
              value={caption}
              onChange={(event) => onCaptionChange(event.target.value)}
            />
          </Field>
          <Field
            label="Tags"
            hint="Separate tags with commas."
            htmlFor="chapter-tags"
          >
            <Input
              id="chapter-tags"
              placeholder="mystery, midpoint, revision"
              value={tags.join(", ")}
              onChange={(event) =>
                onTagsChange(
                  event.target.value
                    .split(",")
                    .map((tag) => tag.trim())
                    .filter(Boolean)
                )
              }
            />
          </Field>
        </div>
      </PopoverContent>
    </Popover>
  );
}
